import React from 'react'
import { useFormContext, Controller } from "react-hook-form";
import {
  Checkbox as ChakraCheckbox,
  FormControl,
} from "@chakra-ui/react";

const Checkbox = ({
  label, name
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl>
      <Controller
        control={control}
        name={name}
        defaultValue={false}
        render={({ field: { onChange, value, ref } }) => (
          <ChakraCheckbox
            onChange={onChange}
            ref={ref}
            isChecked={value}
          >
            {label}
          </ChakraCheckbox>
        )}
      />
    </FormControl>
  )
}

export default Checkbox
